import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QActionsComponent } from './q-actions.component';
import { SuggestionCarouselModule } from 'src/app/components/suggestion-carousel/suggestion-carousel.module';
import { TranslateModule } from '@xref/ngx';
import { MatButtonModule } from '@angular/material/button';
import { SuggestionNotifyModule } from 'src/app/components/suggestion-notify/suggestion-notify.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { defaultPageScrollConfig, NGXPS_CONFIG } from 'ngx-page-scroll-core';

@NgModule({
  declarations: [QActionsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    SuggestionCarouselModule,
    SuggestionNotifyModule,
    FontAwesomeModule
  ],
  exports: [QActionsComponent],
  providers: [
    {provide: NGXPS_CONFIG, useValue: defaultPageScrollConfig}
  ]
})
export class QActionsModule {}
